<template>
  <div :class="{content_print_width: printStatue, columnContent: !printStatue}" id="waterContentId" v-wechat-title="tableData.title">
    <Header :class="{print_statue: printStatue}"/>
    <BannerBg :class="{print_statue: printStatue}"/>
    <div class="page_news_title">
      <div :class="{site_print_width: printStatue, site_width: !printStatue}">
        <div class="padding15">
          <h2>{{ tableData.title }}</h2>
          <span :class="{print_style: printStatue}">
            <i class="fa fa-clock-o" style="margin-left: 0;"></i>{{ formatDate(tableData.created) }}
            <i class="fa fa-eye"></i>浏览次数：{{ tableData.viewCount }}
            <a class="pc_only" :class="{print_statue: printStatue}" @click="htmlCanvas" title="点击打印文章"><img style="float: right; padding-right: 25%;" src="@/assets/images/detail/print_small.png"> </a>
            <a :class="{print_statue: printStatue}" @click="htmlCanvasPdf" title="点击下载文章"><img style="float: right; padding-right: 10px;" src="@/assets/images/detail/download_small.png"> </a>
          </span>
          <div class="clear"></div>
        </div>
      </div>
    </div>
    <div class="news_content_box">
      <div :class="{site_print_width: printStatue, site_width: !printStatue}">
        <!--左侧内容-->
        <div class="width9 watermark_columnContent" :class="{width100: printStatue}">
          <div class="padding_right15">
            <div class="padding15">
              <!-- <div v-if="tableData.summary == null || tableData.summary == '' || tableData.summary == '  '"></div>
              <div v-else class="zhaiyao" :class="{print_style: printStatue}">
                <span>[摘要]</span>
                {{ tableData.summary }}
              </div> -->
              <div :class="{print_style: printStatue, news_content: !printStatue}">
                <quill-editor
                  class="editor"
                  v-model="tableData.content"
                  ref="myQuillEditor"
                  :options="editorOption"
                  @focus="onEditorFocus($event)"
                  @ready="onEditorFocus($event)"
                ></quill-editor>
              </div>
              <div :class="{print_statue: printStatue || routeParams.fromLikeSearch}" class="news_change align_center">
                <ul>
                  <li v-if="tableData.nextId == null">
                    <span><i class="fa fa-arrow-left"></i>上一篇</span>
                  </li>
                  <li v-else>
                    <a @click="contentToNext(tableData.nextId)">
                      <i class="fa fa-arrow-left"></i>上一篇
                    </a>
                  </li>
                  <li>
                    <a @click="contentReturn()">
                      <i class="fa fa-bars"></i>返回目录
                    </a>
                  </li>
                  <li v-if="tableData.preId == null">
                    <span><i class="fa fa-arrow-right"></i>下一篇</span>
                  </li>
                  <li v-else>
                    <a @click="contentToNext(tableData.preId)">
                      <i class="fa fa-arrow-right"></i>下一篇
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!--右侧内容-->
        <div class="width3" :class="{print_statue: printStatue}">
          <div class="right_ybline">
            <div class="padding15">
              <div class="padding_left15">
                <h4 class="sub_title" :class="{print_statue: tableData.lawyersInfo == null}">相关律师</h4>
                <ul class="team_list one_team_list">
                  <li v-for="item in tableData.lawyersInfo" :key="item.id">
                    <a @click="contentToLawyer(item.id)">
                      <div class="lawyer_pic">
                        <img :src=item.pic>
                      </div>
                      <div class="lawyer_int_txt">
                        <h3>{{ item.userName }}</h3>
                        <font>
                          - {{ item.qualification }}
                        </font>
                      </div>
                      <div class="clear"></div>
                    </a>
                  </li>
                  <div class="clear"></div>
                  </ul>
                <div class="pc_only">
                  <h4 class="sub_title">手机分享</h4>
                  <div class="share_box">
                    <div id="qrcode">
                    </div>
                    <p>手机扫一扫
                      <br>分享给我的朋友</p>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <!-- <div class="padding15" :class="{print_statue: printStatue}">
          <div class="news_link wow FadeInB" data-wow-delay=".3s">
            <h4 class="sub_title">您可能感兴趣</h4></div>
        </div>
        <div class="Practices_news wow FadeInB" :class="{print_statue: printStatue}" data-wow-delay=".3s">
          <ul>
            <li v-for="item in tableData" :key="item.id">
              <div class="padding15">
                <a href="#" class="news_link_data">
                  <div class="news_pic">
                      <img :src=item.src>
                    <div class="time">
                      <h3>{{ item.day }}</h3>
                      <span>{{ item.date }}</span></div>
                  </div>
                  <div class="news_detail">
                    <div class="padding15">
                      <h3>根据企业申请破产的主体不同，申请破产可以分为三种方式。债务人申请破产、债权人申请破产以及清算组申请破产。下面我们按照分类根据企业破产法相关规范结合天津地区申请破产实践操作说下申请破产的条件及破产立案问题。</h3>
                      <p>鉴于2017年、2018年及2019年法院受理破产案件还是以破产清算案件占据绝大多数，而且只要企业符合破产清算的条件也可以申请破产重整或者破产和解。所以，我们以申请破产清算案件为主线，穿插说下破产重整与破产和解。</p>
                      <em>阅读详情</em></div>
                  </div>
                </a>
              </div>
            </li>
            <div class="clear"></div>
          </ul>
        </div>
        <div :class="{print_statue: printStatue}" class="home_news_more align_center wow FadeInB" data-wow-delay=".3s">
          <a @click="contentMoreNews()">MORE</a>
        </div> -->
      </div>
    </div>
    <Footer :class="{print_statue: printStatue}"/>
  </div>
</template>

<script>
  const toolbarOptions = []
  import { quillEditor } from "vue-quill-editor"
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import QRCode from 'qrcodejs2'
  import html2Canvas from 'html2canvas'
  import JsPDF from 'jspdf'
  import { removeWatermark, setWaterMark } from '@/assets/js/watermark.js'
  export default {
    props: {
     /*编辑器的内容*/
     value: null
    },
    components: {
      quillEditor
    },
    watch: {
      value(val) {
        this.content = this.value;
      }
    },
    name: "columnContent",
    data() {
      return {
        tableData: {
          title: ''
        },
        editorOption: {
          theme: "bubble", // or 'bubble'
          placeholder: "",
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {}
            }
          }
        },
        params: {
          id: 0
        },
        printStatue: false,
        htmlUpload:'',
        routeParams: {
          id: 0,
          columnId: 0,
          columnName: '首页',
          fromLikeSearch: false,
          parentId: 0
        }
      }
    },
    mounted() {
      if (!(window.sessionStorage.getItem('routeParams') == null || window.sessionStorage.getItem('routeParams') == undefined)){
        this.routeParams = JSON.parse(window.sessionStorage.getItem('routeParams'))
      }
      if (this.$route.params.id) {
        this.params.id = this.$route.params.id
        if (this.$route.params.fromLikeSearch) {
          this.routeParams.fromLikeSearch = true
        }
      } else if (this.$route.params.id == 0){
        this.params.id = 0
      }
      this.htmlUpload = this.$apiUrl.NEWS_PDF_API_URL + this.params.id
      // 第一次初始化组件时，要调用函数进行获取id并查找数据
      this.getRportById ()
    },
    destroyed() {
      removeWatermark()
    },
    methods: {
      onEditorFocus(editor) {
        // 富文本获得焦点时的事件
        editor.enable(false); // 在获取焦点的时候禁用
      },
      getRportById () {
        this.isLoading = true
        this.$axios.get(this.$apiUrl.NEWS_GET_API_URL, 'Json', this.params)
        .then(res => {
          this.isLoading = false
          if (res.data.code == 200) {
            this.tableData = res.data.data
            window.scrollTo(0,0)
            this.qrcode()
            this.sendWaterMark()
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
            this.isLoading = false
            this.$message.error("服务器出现差错")
        })
      },
      htmlCanvas() {
        document.getElementsByTagName('body')[0].style.height = '0px';
        document.getElementsByTagName('html')[0].style.height = '0px';
        window.scrollTo(0,0);
        this.printStatue = true;
        this.loadWaterMark();
        setTimeout(() => {
          window.print(); //  调用打印功能
          this.printStatue = false;
          this.loadWaterMark();
          document.getElementsByTagName('body')[0].style.height = '100%';
          document.getElementsByTagName('html')[0].style.height = '100%';
        }, 1000);
      },
      // 下载导出pdf 文件
      htmlCanvasPdf() {  
        this.$confirm('如果文章内容有图片，请点击“打印”按钮，弹窗右侧“目标打印机”选择“另存为PDF”，然后点击“保存”。另外在点击“打印”按钮之前，需要将文章内容中的图片全部加载显示出来。 是否继续?', '提示', {
          confirmButtonText: '继续',
          cancelButtonText: '去打印'
        }).then(() => {
          document.getElementsByTagName('body')[0].style.height = '0px';
          document.getElementsByTagName('html')[0].style.height = '0px';
          window.scrollTo(0,0);
          this.printStatue = true;
          this.loadWaterMark();
          const _this = this
          setTimeout(() => {
            // 导出pdf
            let page = document.querySelector('#waterContentId')
            var title = _this.tableData.title
            html2Canvas(page, {
              allowTaint: true,
              useCORS: true
            }).then(function(canvas) {
              let contentWidth = canvas.width
              let contentHeight = canvas.height
              let pageHeight = contentWidth / 592.28 * 841.89
              let leftHeight = contentHeight
              let position = 0
              let imgWidth = 595.28
              let imgHeight = 592.28 / contentWidth * contentHeight

              let pageData = new Image()
              //设置图片跨域访问
              pageData.setAttribute('crossOrigin', 'Anonymous')

              setTimeout(() => {
                  pageData = canvas.toDataURL('image/jpeg', 1.0)
                  let PDF = new JsPDF('', 'pt', 'a4')
                  if (leftHeight < pageHeight) {
                      PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
                  } else {
                      while (leftHeight > 0) {
                          PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                          leftHeight -= pageHeight
                          position -= 841.89
                          if (leftHeight > 0) {
                              PDF.addPage()
                          }
                      }
                  }
                  _this.printStatue = false
                  _this.loadWaterMark()
                  document.getElementsByTagName('body')[0].style.height = '100%'
                  document.getElementsByTagName('html')[0].style.height = '100%'
                  PDF.save(title + '.pdf')
              }, 1000)
            })
          }, 1000)
        }).catch(() => {
          
        }) 
      },

      // 新闻二维码
      qrcode () {
        document.getElementById("qrcode").innerHTML="";
        var qrcodecontext = document.location.href;
        qrcodecontext = qrcodecontext.substring(0, qrcodecontext.lastIndexOf("/")+1)
        qrcodecontext = qrcodecontext + this.params.id
        qrcodecontext = qrcodecontext.substring(0, 4).toLowerCase() == "http" ? qrcodecontext : "http://" + qrcodecontext;
        var qrnode = new QRCode('qrcode', { correctLevel: 0, text: qrcodecontext, width: 100, height: 100, background: "#fff", foreground: "#000" });
      },
      contentToNext(id) {
        if (id == null) return
        this.params.id = id
        this.getRportById ()
      },
      contentReturn() {
        this.$router.back()
      },
      contentToLawyer(id) {
        this.$router.push('/lawyerDetail/' + id)
      },
      contentMoreNews() {
        this.$router.push({
          name: 'columnNews',
          params: {
            id: this.$route.params.columnId,
            name: this.$route.params.columnName,
            parentId: this.$route.params.parentId
          }
        })
      },
      loadWaterMark() {
        removeWatermark()
        this.sendWaterMark()
      },
      sendWaterMark() {
        const _this = this
        setTimeout(function() {
          let width = $('.news_content_box').width()
          let top = _this.printStatue ? 0 : $('.banner_bg').height()
          let height = $('.page_news_title').height() + $('.watermark_columnContent').height()
          setWaterMark('', '天津金展律师事务所', height, width, top)
        }, 200)
      },
      formatDate(date) {
          if(date == undefined){
          return ''
        }
          return this.$moment(date).format("YYYY-MM-DD")
      }
    // },
    // watch: { // watch 是对象，用于监听属性使用
    //   '$route': function () {
    //     this.getRportById()
    //   }
    }
  }
</script>
<style scoped>
  .print_statue {
    display: none;
  }
  .print_style {
    font-size: 18px;
  }
</style>